import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

interface itemsDragDrop {
  label: string,
  id: string,
  order: number
}
@Component({
  selector: 'so-drag-drop-list',
  templateUrl: './so-drag-drop-list.component.html',
  styleUrls: ['./so-drag-drop-list.component.scss']
})
export class SoDragDropListComponent {
  @Input({required: true}) items: itemsDragDrop[] = [];
  @Input() notFoundText: string = '';
  @Input() showFullText: boolean = true;

  @Output() onDelete: EventEmitter<itemsDragDrop> = new EventEmitter<itemsDragDrop>();
  @Output() onEdit: EventEmitter<itemsDragDrop> = new EventEmitter<itemsDragDrop>();

  public drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.items, event.previousIndex, event.currentIndex);
  }

  public editItem(value: itemsDragDrop){
    this.onEdit.emit(value)
  }

  public deleteItem(value: itemsDragDrop){
    this.onDelete.emit(value );
  }
}
